module.exports = __webpack_public_path__ + "img/bumazhnaja-produktsija.24ba89d4.svg";